import React, { useEffect } from "react";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getKey, resetResend } from "../../features/userSlice";
import EmailVarifyModal from "./EmailVarifyModal";
import { useNavigate } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import ChangePassword from "./ChangePassword";
import PriceModal from "./PriceModal";
import InsuranceModal from "./InsuranceModal";
import ResetEmailModal from "./ResetEmailModal";
import ResetPassword from "./ResetPassword";

const MainModal = ({
  modal,
  show,
  setShow,
  setModal,
  extraData,
  handleEditInsurance,
}) => {
  const key = useSelector(getKey);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // if (modal === "emailVarification") {
    //   setModal("emailVarification");
    // }
    // if (modal === "dailyRates") {
    //   setModal("dailyRates");
    // }
    // if (modal === "insurance") {
    //   setModal("insurance");
    // }
    // modal !== "login" && setModal("login");
  }, [show]);

  useEffect(() => {
    if (key !== "" && key !== undefined && key !== null) {
      dispatch(resetResend());
      // navigate(window.location.pathname, { state: { otp: true } });

      // setModal("emailVarification");
      // setShow(true);
    }
  }, [key]);

  switch (modal) {
    case "login":
      return <LoginModal vals={{ show, setShow, setModal, extraData }} />;
      break;
    case "register":
      return <RegisterModal vals={{ show, setShow, setModal, extraData }} />;
      break;
    case "emailVarification":
      return <EmailVarifyModal vals={{ show, setShow, setModal }} />;
      break;
    case "forgotPassword":
      return <ForgotPassword vals={{ show, setShow, setModal }} />;
      break;
    case "changePassword":
      return <ChangePassword vals={{ show, setShow, setModal }} />;
      break;
    case "dailyRates":
      return <PriceModal vals={{ show, setShow, setModal, extraData }} />;
      break;
    case "insurance":
      return (
        <InsuranceModal
          vals={{ show, setShow, setModal, handleEditInsurance }}
        />
      );
      break;
    case "resetEmail":
      return <ResetEmailModal vals={{ show, setShow, setModal }} />;
      break;
    case "resetPassword":
      return <ResetPassword vals={{ show, setShow, setModal }} />;
      break;
    default:
      <LoginModal vals={{ show, setShow, setModal }} />;
  }
};

export default MainModal;
